import common from './common';
import { CardForecastThreeDays } from './card-forecast-three-days';

const safeJsonParse = (text) => {
  try {
    return JSON.parse(text);
  } catch {
    const start = Math.min(
      ...[text.indexOf('{'), text.indexOf('[')].filter(i => i !== -1)
    );
    const end = Math.max(
      text.lastIndexOf('}'),
      text.lastIndexOf(']')
    );

    if (start === -1 || end === -1 || end <= start) {
      throw new Error('Resposta não contém JSON válido.');
    }

    const jsonString = text.slice(start, end + 1);
    return JSON.parse(jsonString);
  }
};

const getRainDropsSrc = (precipitation) => {
  if (precipitation >= 30) {
    return Array(3).fill("/dist/images/gota-azul.png");
  } else if (precipitation >= 10) {
    return [
      "/dist/images/gota-azul.png",
      "/dist/images/gota-azul.png",
      "/dist/images/gota-cinza.png"
    ];
  } else if (precipitation > 0) {
    return [
      "/dist/images/gota-azul.png",
      "/dist/images/gota-cinza.png",
      "/dist/images/gota-cinza.png"
    ];
  } else {
    return Array(3).fill("/dist/images/gota-cinza.png");
  }
};
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, options = {}) => {
  const {
    domain = window.location.hostname,
    path = '/',
    expires = ''
  } = options;

  let cookieStr = `${name}=${encodeURIComponent(value)}; path=${path}; domain=.${domain}`;
  if (expires) cookieStr += `; expires=${expires}`;
  document.cookie = cookieStr;
};



let alreadyRequested = false;

const geolocation = {

  getUserLocation: () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
        localStorage.setItem('requestedLocation', 'true');
      } else {
        reject(new Error("Geolocalização não é suportada por este navegador."));
      }
    });
  },

  userGeolocation: async (verifyRequested = false) => {
    if (!verifyRequested)
      if (alreadyRequested || sessionStorage.getItem('__geo_user_location_requested')) return;
    alreadyRequested = true;

    const fallbackToSaoPaulo = async () => {
      console.warn("Iniciando fallback: buscando dados de São Paulo.");

      const [permissionStatus] = await Promise.all([navigator.permissions.query({ name: "geolocation" }), geolocation.renderFromCookiesOrCache(3477, 558, 'São Paulo', 'SP')]);

      if (permissionStatus.state !== "granted") {
        const icon = $('<img>', { src: `/dist/images/v2/svg/location-denied.svg`, alt: 'Localização desabilitada', width: 16, height: 16 });
        $('#current-weather-icon-header').html(icon);

        const locationRainIcon = $('<img>', {
          src: '/dist/images/v2/svg/location-rain-forecast-deny-icon.svg',
          id: 'icon-location-card',
          width: 24,
          height: 24,
          alt: 'Localização desabilitada',

        });

        $('#icon-location-card').remove();
        $('#city-btn-card').prepend(locationRainIcon);
        $('#city-name-card').text('São Paulo');
      }
    };

    const cookieCity = getCookie('__geo_city');
    const cookieLocale = getCookie('__geo_locale');
    const cookieName = getCookie('__geo_name');
    const cookieUf = getCookie('__geo_uf');

    const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

    if (cookieCity && cookieLocale && cookieName && cookieUf && permissionStatus.state !== "granted") {
      await geolocation.renderFromCookiesOrCache(cookieLocale, cookieCity, cookieName, cookieUf);
      sessionStorage.setItem('__geo_user_location_requested', 'true');
      return {
        idlocale: cookieLocale,
        idcity: cookieCity,
        city: cookieName,
        uf: cookieUf
      };
    }

    try {
      const position = await geolocation.getUserLocation();
      const formData = new URLSearchParams();
      formData.append('latitude', position.coords.latitude.toFixed(5));
      formData.append('longitude', position.coords.longitude.toFixed(5));

      const response = await fetch('/json/minha-localizacao', { method: 'POST', body: formData });
      if (!response.ok) throw new Error(`Erro na resposta do servidor: ${response.statusText}`);

      const result = await response.json();
      const locationData = result?.data?.[0];

      if (!locationData) {
        console.warn("Dados de localização não encontrados:", result);
        await fallbackToSaoPaulo();
        return null;
      }

      const { idlocale, idcity, city, uf } = locationData;

      await geolocation.renderFromCookiesOrCache(idlocale, idcity, city, uf);
      $('#questionStep').css('display', 'flex');
      $("#useMyCurrentLocationStep").css('display', 'none');

      return { idlocale, idcity, city, uf };

    } catch (error) {
      console.error("Falha ao obter e processar a localização:", error.message);
      $('#useMyCurrentLocationStep').css('display', 'flex');
      $('#questionStep').css('display', 'none');
      await fallbackToSaoPaulo();
      return null;
    }
  },

  hasAlreadyRendered: (idlocale, idcity) => {
    const cache = sessionStorage.getItem('__geo_last_render');
    console.warn("Utilizando dados de localização em cache");
    if (!cache) return false;

    try {
      const { lastLocale, lastCity, timestamp } = JSON.parse(cache);
      const fifteenMinutes = 15 * 60 * 1000;
      const now = Date.now();

      const isSameLocation = lastLocale === String(idlocale) && lastCity === String(idcity);
      const isRecent = timestamp && (now - timestamp < fifteenMinutes);

      return isSameLocation && isRecent;
    } catch {
      return false;
    }
  },

  setRenderCache: (idlocale, idcity) => {
    sessionStorage.setItem('__geo_last_render', JSON.stringify({
      lastLocale: String(idlocale),
      lastCity: String(idcity),
      timestamp: Date.now()
    }));
  },

  updateSidebarWeatherLinks: (idcity, cityName, uf) => {
    const dynamicLinks = document.querySelectorAll('a[data-category="previsao-tempo"]');
    if (!dynamicLinks.length) {
      return;
    }

    const citySlug = `${common.createSlug(cityName)}-${String(uf).toLowerCase()}`;

    dynamicLinks.forEach(link => {
      const templateHref = link.getAttribute('data-href-template') || link.getAttribute('href') || '';

      if (!templateHref.includes('{id}')) {
        return;
      }

      const newHref = templateHref
        .replace('{id}', String(idcity))
        .replace('{cidade}-{sigla-estado}', citySlug);

      link.setAttribute('href', newHref);
    });
  },

  renderFromCookiesOrCache: async (idlocale, idcity, cityName, uf) => {
    const alreadyRendered = geolocation.hasAlreadyRendered(idlocale, idcity);

    if (!alreadyRendered) {
      await geolocation.runWeatherRequestsInParallel(idlocale, idcity);
      geolocation.setRenderCache(idlocale, idcity);
    } else {
      // Quando já renderizado recentemente, ainda precisamos atualizar
      // a previsão de chuva e as praias próximas para manter os cards sincronizados.
      await Promise.allSettled([
        geolocation.renderWeatherNowByGeolocation(idlocale, idcity),
        geolocation.updateRainForecastChart(idlocale, idcity),
        geolocation.updateNearbyBeaches(idlocale)
      ]);
    }

    common.dynamicLink(idcity, cityName, uf);
    geolocation.updateSidebarWeatherLinks(idcity, cityName, uf);
    $('[data-id=geolocated]').removeClass('-hidden-geolocated');
    $('[data-id=geolocated] .city').html(`${cityName}, ${uf}`);
  },

  runWeatherRequestsInParallel: async (idlocale, idcity) => {
    return Promise.allSettled([
      geolocation.renderWeatherNowByGeolocation(idlocale),
      geolocation.updateDaysCards(idlocale),
      geolocation.updateNearbyBeaches(idlocale),
      geolocation.updateRainForecastChart(idlocale, idcity)
    ]);
  },

  renderWeatherNowByGeolocation: async (idlocale, idcity) => {
    try {
      const url = `/json/myclimatempo/user/weatherNow?idlocale=${idlocale}`;
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const responseText = await response.text();
      const result = safeJsonParse(responseText);
      const dataPath = result?.data?.getWeatherNow?.[0]?.data?.[0];

      if (!dataPath?.locale || !dataPath.weather) return;

      const { locale, weather } = dataPath;
      const slug = common.createSlug(locale.city);
      const acronym = (locale.ac === 'BR') ? locale.uf : locale.ac;
      const cityName = `${locale.city}, ${acronym}`;
      const cityUrl = `${locale.idcity}/${slug}-${acronym.toLowerCase()}`;
      const todayUrl = `/previsao-do-tempo/cidade/${cityUrl}`;
      const tomorrowUrl = `/previsao-do-tempo/amanha/cidade/${cityUrl}`;
      const city15DaysUrl = `/previsao-do-tempo/15-dias/cidade/${cityUrl}`;

      if (
        $('[data-current-weather]').length > 0 &&
        idlocale &&
        locale?.idcity &&
        locale?.name &&
        locale?.uf
      ) {
        setCookie('__geo_locale', idlocale);
        setCookie('__geo_city', locale.idcity);
        setCookie('__geo_name', locale.city);
        setCookie('__geo_uf', locale.uf);
      }


      $('[data-id=geolocated]').removeClass('-hidden-geolocated');
      $('[data-id=geolocated] .city').html(cityName);
      $('[data-id=geolocated] .temperature').html(`${weather.temperature ?? '-'}&deg;`);
      $('[data-id=geolocated] .ico').attr('src', `/dist/images/v2/svg/outline/${weather.icon}.svg`);

      const basePath = window.location.href.includes('agroclima')
        ? `/agroclima/previsao-do-tempo/15-dias/cidade/`
        : `/previsao-do-tempo/cidade/`;

      $('[data-id=geolocated] .link').attr('href', `${basePath}${cityUrl}`);

      if ($('[data-current-weather]').length > 0) {
        const locationDeniedIcon = $('<img>', { src: `/dist/images/v2/svg/location-denied.svg`, alt: 'Localização desabilitada', width: 16, height: 16 });
        const weatherNowicon = $('<img>', { src: `/dist/images/v2/svg/${weather.icon}.svg`, alt: `Ícone do tempo agora em ${cityName}`, width: 40, height: 40 });

        $('#current-weather-icon').html(weatherNowicon);
        $('#current-weather-city').html(cityName);
        $('#current-weather-icon-header').html(locationDeniedIcon);
        $('#current-weather-city-header').html(cityName);
        $('#current-weather-link').attr('href', "#");
        $('#current-weather-temperature').html(`${weather.temperature ?? '-'}&deg;`);
        $('#current-weather-condition').html(`${weather.condition ?? ''}`);
        $('#current-weather-sensation').html(`${weather.sensation ?? '-'}&deg;`);
        $('#current-weather-humidity').html(`${weather.humidity ?? '-'}%`);
        $('#current-weather-pressure').html(`${weather.pressure ?? '-'} hPa`);
        $('#current-weather-wind').html(`${weather.windVelocity ?? '-'}km/h`);
        $('#current-weather-updated-at').html(`${weather.dateUpdate ?? ''}`);
        $('[data-id=Card_TempoAgora_Button_Today]').attr('href', todayUrl);
        $('[data-id=Card_TempoAgora_Button_Tomorrow]').attr('href', tomorrowUrl);
        $('[data-id=Card_TempoAgora_Button_15days]').attr('href', city15DaysUrl);
        $('[data-current-weather] .shimmer-placeholder').removeClass('shimmer-placeholder');

        const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

        if (permissionStatus.state === "granted") {
          const locationGrantedIcon = $('<img>', { src: `/dist/images/v2/svg/location-granted.svg`, alt: `Ícone do tempo agora em ${cityName}`, width: 16, height: 16 });

          const locationRainIcon = $('<img>', {
            src: '/dist/images/v2/svg/location-rain-forecast-icon.svg',
            id: 'icon-location-card',
            width: 24,
            height: 24,
            alt: 'Localização desabilitada',

          });
          $('#icon-location-card').remove();
          $('#city-btn-card').prepend(locationRainIcon);
          $('#city-name-card').text(locale.city);
          $('#city-name-card').attr('title', `Ver a previsão completa para ${locale.city}`);
          $('#city-name-card').attr('aria-label', `Ver a previsão completa para ${locale.city} - ${locale.uf}`);
          $('#city-name-card').attr('role', 'link');
          $('#city-btn-card').attr('href', `/previsao-do-tempo/cidade/${cityUrl}`);
          $('#city-btn-card').removeAttr('onclick');
          $('#city-btn-card').attr('data-id', 'Card_RainForecast_Link_Location');

          $('#current-weather-icon-header').html(locationGrantedIcon);
          $('#current-weather-link').attr('href', todayUrl);
          $('#current-weather-link').attr('role', 'link');
          $('#current-weather-link')[0].onclick = null;
        }
      }

      geolocation.errorHitCurrentWeather(weather);
      CardForecastThreeDays.load(idlocale, todayUrl, city15DaysUrl);

    } catch (error) {
      console.error("Erro ao renderizar clima atual:", error);
    }
  },

  updateDaysCards: async (idlocale) => {
    try {
      const url = `/json/myclimatempo/user/forecastFiveDays?idlocale=${idlocale}`;
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      const result = safeJsonParse(text);

      const infoCity = result?.infoCity;
      if (infoCity) {
        const slug = common.createSlug(infoCity.city);
        const acronym = (infoCity.ac === 'BR') ? infoCity.uf : infoCity.ac;
        const cityUrl = `${infoCity.idcity}/${slug}-${acronym.toLowerCase()}`;
        $('#Botao_card_previsao_1').attr('href', `/previsao-do-tempo/cidade/${cityUrl}`);
        $('#Botao_card_previsao_2').attr('href', `/previsao-do-tempo/amanha/cidade/${cityUrl}`);
        $('#Botao_card_previsao_3').attr('href', `/previsao-do-tempo/15-dias/cidade/${cityUrl}`);
      }

      const data = result?.data?.getFiveDaysForecast?.slice(0, 3) || [];
      data.forEach((forecast, index) => {
        const prec = forecast.rain?.precipitation ?? 0;
        const rainDropsSrc = getRainDropsSrc(prec);

        const dayIndex = index + 1;
        const $wrapper = $(`#forecast-card-rain-drops-wrapper-${dayIndex}`);
        $wrapper.empty();
        rainDropsSrc.forEach((src, i) => {
          $wrapper.append($('<img>', { class: "lazyload _width-auto", src, alt: `Gota ${i + 1}`, width: 10, height: 10 }));
        });

        $(`#day-forecast-card-icon-${dayIndex}`).attr('src', `/dist/images/v2/svg/${forecast.textIcon.icon.day}.svg`);
        $(`#forecast-card-min-temp-${dayIndex}`).html(`${forecast.temperature.min}&deg;`);
        $(`#forecast-card-max-temp-${dayIndex}`).html(`${forecast.temperature.max}&deg;`);
        $(`#forecast-card-rain-${dayIndex}`).html(`${prec}mm - ${forecast.rain.probability}%`);
      });
    } catch (error) {
      console.error("Erro ao atualizar os cards de previsão:", error);
    }
  },

  updateRainForecastChart: async (idlocale, idcity) => {
    const url = `/json/myclimatempo/user/rainForecastSevenDays?idlocale=${idlocale}`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro HTTP: ${response.status}`);
      const text = await response.text();
      const data = safeJsonParse(text);

      const days = Array.isArray(data?.rain) ? data.rain : [];
      const forecastDailyRain = days.map(day => {
        const r = day?.rain ?? day;
        return {
          date: r?.date ?? null,
          dayWeek: r?.dayWeek ?? null,
          precipitation: r?.precipitation ?? null,
          probability: r?.probability ?? null
        };
      });
      if (forecastDailyRain && forecastDailyRain.length) {
        document.dispatchEvent(new CustomEvent('rainForecastReady', {
          detail: { forecastDailyRain }
        }));
      }
      return forecastDailyRain;
    } catch (error) {
      console.error("Erro ao obter previsão de chuva:", error);
      return [];
    }
  },

  renderRainForecastList: (list = []) => {
    const $container = $('#rain-forecast-list');
    if (!$container.length || !Array.isArray(list) || list.length === 0) return;

    const rows = list.map((forecast) => {
      const precipitation = Number(
        (forecast && forecast.rain && forecast.rain.precipitation) ?? forecast?.precipitation ?? 0
      );
      const rainPercentage = Math.round(precipitation);

      let intensity = 'medium';
      if (rainPercentage >= 75) intensity = 'very-high';
      else if (rainPercentage >= 50) intensity = 'high';
      else if (rainPercentage >= 25) intensity = 'medium';

      const dayWeek = forecast?.dayWeek ?? '';
      const dateVal = forecast?.date ?? '';
      const d = new Date(dateVal);
      const isValid = !isNaN(d);
      const display = isValid
        ? `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
        : `${dateVal}`;
      const datetime = isValid ? d.toISOString().slice(0, 10) : `${dateVal}`;

      const precRound = Math.round(precipitation);

      return `
        <div class="rain-row _flex _align-center _space-between _margin-b-15 -gray-dark-2 -font-12" role="row">
          <span class="metrics-rain-text" role="cell" aria-label="Volume de chuva: ${precRound} milímetros">
            <span>${precRound}</span>
            <span>mm</span>
          </span>
          <div class="rain-progress" style="flex:1" aria-label="Nível de precipitação: ${precRound}mm de ${rainPercentage}%" role="meter" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${rainPercentage}" data-tooltip="${rainPercentage}% de precipitação (${precRound}mm)" tabindex="0" title="${rainPercentage}% de precipitação (${precRound}mm)">
            <span style="width: ${rainPercentage}%" data-intensity="${intensity}" aria-hidden="true"></span>
          </div>
          <div class="_center" style="min-width:60px" role="cell">
            <span class="metrics-rain-text" aria-label="Dia da semana: ${dayWeek}">${dayWeek}</span>
            <time class="metrics-rain-text _block" datetime="${datetime}" aria-label="Data: ${display}">${display}</time>
          </div>
        </div>
      `;
    }).join('');

    $container.html(rows);
  },

  updateNearbyBeaches: async (idlocale) => {
    try {
      const url = `/json/myclimatempo/user/nearbyBeaches?idlocale=${idlocale}`;
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      const beaches = safeJsonParse(text);

      // Suporte a dois layouts: UL antigo (#nearby-beaches-card-ul) e markup atual (.content-nearby-beaches)
      const $ulContainer = $("#nearby-beaches-card-ul");
      const $divContainer = $(".content-nearby-beaches");

      // Seleciona o container disponível
      const $container = $ulContainer.length ? $ulContainer : $divContainer;
      if (!$container.length) return;
      $container.empty();

      if (!Array.isArray(beaches) || beaches.length === 0) {
        if ($ulContainer.length) {
          $container.append('<li>Nenhuma praia próxima encontrada.</li>');
        } else {
          $container.append('<p class="-gray">Nenhuma praia próxima encontrada.</p>');
        }
        return;
      }

      beaches.forEach((beach, idx) => {
        const prec = parseFloat(beach?.weather?.rain?.precipitation ?? 0);
        const prob = parseFloat(beach?.weather?.rain?.probability ?? 0);
        const min = beach?.weather?.temperature?.min ?? '-';
        const max = beach?.weather?.temperature?.max ?? '-';
        const icon = beach?.weather?.textIcon?.icon?.day ?? 'cloud';
        const iconAlt = beach?.weather?.textIcon?.text?.pt ?? '';
        const idbeach = beach?.info?.idbeach;
        const slug = beach?.info?.slugBeach;
        const uf = (beach?.info?.uf || '').toLowerCase();
        const name = beach?.info?.beach || '';

        const rainDropsSrc = getRainDropsSrc(prec);

        if ($ulContainer.length) {
          // Layout antigo baseado em <ul><li>
          const rainDrops = rainDropsSrc.map(src =>
            `<img class="_width-10 lazyload" data-src="${src}" width="10" height="10" alt="">`
          ).join('');

          $container.append(`
            <li class="item _padding-lr-10 _flex _align-center _space-between${idx !== 0 ? ' _padding-t-20' : ''}${idx !== beaches.length - 1 ? ' _padding-b-20 _border-b-light-1' : ''}">
              <div class="_flex _align-center">
                <img class="lazyload _margin-r-20" data-src="/dist/images/v2/svg/${icon}.svg" width="33" height="33" alt="${iconAlt}" />
                <div>
                  <a href="/previsao-do-tempo/litoral/${idbeach}/${slug}-${uf}" class="-bold -gray-dark-2 _margin-b-5 _block">${name}</a>
                  <p class="-gray _flex _align-center">
                    <img src="/dist/images/v2/svg/ic-arrow-min.svg" class="_margin-r-5 _margin-b-3" width="12" height="12" alt="mínima">
                    ${min}
                    <img src="/dist/images/v2/svg/ic-arrow-max.svg" class="_margin-l-10 _margin-r-5 _margin-b-3" width="12" height="12" alt="máxima">
                    ${max}
                  </p>
                  <p class="-gray _flex _align-center">${rainDrops} ${prec}mm - ${prob}%</p>
                </div>
              </div>
            </li>
          `);
        } else {
          // Layout atual: ancora .item-beach
          const drops = rainDropsSrc.map((src, i) =>
            `<img class="_width-10${i === 2 ? ' _margin-r-5' : ''} lazyload" width="10" height="10" data-src="${src}" alt="">`
          ).join('');

          $container.append(`
            <a href="/previsao-do-tempo/litoral/${idbeach}/${slug}-${uf}" class="item-beach">
              <div class="item-beach-icon">
                <img src="/dist/images/v2/svg/${icon}.svg" width="32" height="32" loading="lazy" alt="${iconAlt}">
              </div>
              <div class="item-beach-info">
                <div class="item-beach-city">
                  <p>${name}</p>
                </div>
                <div class="item-beach-weather">
                  <p class="item-beach-weather-temp-min">${min}°</p>
                  <p class="item-beach-weather-temp-max">${max}°</p>
                  ${drops}
                  <p class="item-beach-rain">${prec}mm - ${prob}%</p>
                </div>
              </div>
            </a>
          `);
        }
      });
    } catch (error) {
      console.error("Erro ao atualizar praias próximas:", error);
    }
  },

  errorHitCurrentWeather: (weather) => {
    if (!weather.icon) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'error_hit', name: 'data_aggregator_now_icon' });
    }
    if (!weather.temperature) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'error_hit', name: 'data_aggregator_now_temperature' });
    }
  },
};

export default geolocation;
 
// Re-render rain forecast card when data becomes available
document.addEventListener('rainForecastReady', (event) => {
  try {
    const list = event?.detail?.forecastDailyRain || [];
    if (!Array.isArray(list) || list.length === 0) return;
    geolocation.renderRainForecastList(list);
  } catch (e) {
    console.error('Falha ao renderizar previsão de chuva (evento):', e);
  }
});
